// extracted by mini-css-extract-plugin
module.exports = {"content":"HiddenBox_content__xJw9m","dark":"HiddenBox_dark__2CUnY","light":"HiddenBox_light__3xBH2","cancel-btn":"HiddenBox_cancel-btn__3AHmU"};